import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArquivoAnaliseDeRiscoMainComponent } from './arquivo-analise-de-risco-main/arquivo-analise-de-risco-main.component';
import { GlobalModule } from 'src/app/global/global.module';

@NgModule({
  declarations: [ArquivoAnaliseDeRiscoMainComponent],
  imports: [CommonModule, GlobalModule],
})
export class ArquivoAnaliseDeRiscoModule {}
